import { CircleFlag } from 'react-circle-flags';
import React, { ReactNode } from 'react';
import { supportedLocales } from './Constants';
import 'flag-icon-css/css/flag-icons.min.css';

export type Language = {
  value: string;
  label: string;
  icon: ReactNode;
  squareIcon?: ReactNode;
};

export const allLanguages: Language[] = [
  {
    value: 'en',
    label: 'English',
    icon: <CircleFlag countryCode="gb" style={{ height: 24, width: 24 }} />,
    squareIcon: <span className="flag-icon flag-icon-gb" />,
  },
  {
    value: 'ja',
    label: '日本語',
    icon: <CircleFlag countryCode="jp" style={{ height: 24, width: 24 }} />,
    squareIcon: <span className="flag-icon flag-icon-jp" />,
  },
  {
    value: 'fr',
    label: 'Français',
    icon: <CircleFlag countryCode="fr" style={{ height: 24, width: 24 }} />,
    squareIcon: <span className="flag-icon flag-icon-fr" />,
  },
  {
    value: 'de',
    label: 'Deutsch',
    icon: <CircleFlag countryCode="de" style={{ height: 24, width: 24 }} />,
    squareIcon: <span className="flag-icon flag-icon-de" />,
  },
  {
    value: 'nl',
    label: 'Néerlandais',
    icon: <CircleFlag countryCode="nl" style={{ height: 24, width: 24 }} />,
    squareIcon: <span className="flag-icon flag-icon-nl" />,
  },
  {
    value: 'es',
    label: 'Español',
    icon: <CircleFlag countryCode="es" style={{ height: 24, width: 24 }} />,
    squareIcon: <span className="flag-icon flag-icon-es" />,
  },
  {
    value: 'pt',
    label: 'Portuguese',
    icon: <CircleFlag countryCode="pt" style={{ height: 24, width: 24 }} />,
    squareIcon: <span className="flag-icon flag-icon-pt" />,
  },
  {
    value: 'ar',
    label: 'العربية',
    icon: <CircleFlag countryCode="sa" style={{ height: 24, width: 24 }} />,
    squareIcon: <span className="flag-icon flag-icon-sa" />,
  },
  {
    value: 'it',
    label: 'Italiano',
    icon: <CircleFlag countryCode="it" style={{ height: 24, width: 24 }} />,
    squareIcon: <span className="flag-icon flag-icon-it" />,
  },
  {
    value: 'zh',
    label: '中文',
    icon: <CircleFlag countryCode="cn" style={{ height: 24, width: 24 }} />,
    squareIcon: <span className="flag-icon flag-icon-cn" />,
  },
  {
    value: 'th',
    label: 'ททท',
    icon: <CircleFlag countryCode="th" style={{ height: 24, width: 24 }} />,
    squareIcon: <span className="flag-icon flag-icon-th" />,
  },
  {
    value: 'ko',
    label: '한국인',
    icon: <CircleFlag countryCode="kr" style={{ height: 24, width: 24 }} />,
    squareIcon: <span className="flag-icon flag-icon-kr" />,
  },
  {
    value: 'vi',
    label: 'Tiếng Việt',
    icon: <CircleFlag countryCode="vn" style={{ height: 24, width: 24 }} />,
    squareIcon: <span className="flag-icon flag-icon-vn" />,
  },
  {
    value: 'id',
    label: 'Bahasa Indonesia',
    icon: <CircleFlag countryCode="id" style={{ height: 24, width: 24 }} />,
    squareIcon: <span className="flag-icon flag-icon-id" />,
  },
  {
    value: 'fa',
    label: 'پارسی',
    icon: <CircleFlag countryCode="ir" style={{ height: 24, width: 24 }} />,
    squareIcon: <span className="flag-icon flag-icon-ir" />,
  },
  {
    value: 'tr',
    label: 'Türkçe',
    icon: <CircleFlag countryCode="tr" style={{ height: 24, width: 24 }} />,
    squareIcon: <span className="flag-icon flag-icon-tr" />,
  },
  {
    value: 'ms',
    label: 'Bahasa Melayu',
    icon: <CircleFlag countryCode="my" style={{ height: 24, width: 24 }} />,
    squareIcon: <span className="flag-icon flag-icon-my" />,
  },
  {
    value: 'ph',
    label: 'Philipino',
    icon: <CircleFlag countryCode="ph" style={{ height: 24, width: 24 }} />,
    squareIcon: <span className="flag-icon flag-icon-ph" />,
  },
  {
    value: 'cs',
    label: 'Čeština',
    icon: <CircleFlag countryCode="cz" style={{ height: 24, width: 24 }} />,
    squareIcon: <span className="flag-icon flag-icon-cz" />,
  },
];

export const languages = allLanguages.filter(({ value }) => supportedLocales.includes(value));
